import axios from 'axios';
import qs from 'qs';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
})



export function post(options) {
  const params = {
    method: options.method,     //API方法
    appkey: this.$global.appkey || this.getLocal("appkey") || "dumovie_wap",     //终端设备标识（服务端提供）
    sign: '',     //加密值
    timestamp: this.timestamp(),     //当前时间戳（yyyyMMddHHmmss）
  }
  const data = options ? Object.assign(options, params) : params
  let handleData = {}
  let handleObj = Object.keys(data).filter(item => data[item] !== '').map(item => handleData[item] = data[item])

  let sign = this.$md5(this.handleSign(handleData)).toUpperCase()
  let innerData = {
    ...handleData,
    sign: sign
  }

  axios.defaults.withCredentials = false;
  return new Promise((resolve, reject) => {
    axios.post(this.$global.baseUrl, qs.stringify(innerData))
      .then(res => {
        resolve(res.data);
        let isKfc = this.getLocal("isKfc") ? this.getLocal("isKfc") : ""
          // console.log("isKfc", isKfc)
        if (res.data.error.code === '1003') {
          this.removeLocal("auth_code");
          this.removeLocal("phoneNo");
          this.removeLocal("hasLogged");
          let isKfc = this.getLocal("isKfc") ? this.getLocal("isKfc") : ""
          this.$router.push({path: '/logup', query: {isKfc: isKfc}});
        } else if (res.data.error.code === '6021') {
          this.$router.push({ path: "/orderList", query: { orderStatus: "pending" } })
        } else if (res.data.error.code === '1001'){
          this.$router.push("/errPage")
        }
      })
      .catch(err => {
        reject(err.data)
      })
  });
}


// WEBPACK FOOTER //
// ./src/api/http.js